import { KeyboardEvent } from 'react';

/**
 * @param event - The keyboard event triggered by the user's key press.
 * @param regex - The regular expression to test the allowed characters.
 */
const handleCheckKey = (
  event: KeyboardEvent<HTMLInputElement>,
  regex: RegExp,
) => {
  if (!regex.test(event.key) && event.key !== 'Backspace') {
    event.preventDefault();
  }
};

export const handleCheckKeyForMail = (
  event: KeyboardEvent<HTMLInputElement>,
) => {
  const mailRegex = /^[a-zA-Z0-9@.]/;
  handleCheckKey(event, mailRegex);
};

export const validateGeneral = (event: KeyboardEvent<HTMLInputElement>) => {
  const generalRegex = /^[a-zA-Zа-яА-ЯəöğüşçƏÖĞÜŞÇıİ0-9\s,.:"'_;()-]*$/;
  handleCheckKey(event, generalRegex);
};
